import { React, useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import { Toaster, toast } from "react-hot-toast";
import axios from "axios";
import AsyncSelect from "react-select/async";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { addFacilityRegistration } from "actions/action";
import { updateFacilityRegistration } from "actions/action";
import "react-datepicker/dist/react-datepicker.css";
import { isSameDay, isWithinInterval, parseISO } from "date-fns";
import { getBookedSlots } from "actions/action";
import SubmittingModal from "components/Modal";
import ImageCarouselInfo from "components/ImageCarousalInfo";


export default function StudentCreateFacilityReservation() {
  let viewFlag = false;
  const location = useLocation();
  const { type, fid, fname, formValues, facility } = location.state;
  const userId = localStorage.getItem("user_id");
  const clubId = localStorage.getItem("club_id");
  const userName = localStorage.getItem("user_name");
  const clubName = localStorage.getItem("club_name");
  const [loggedInUserInfo, setLoggedInUserInfo] = useState({
    clubId,
    clubName,
    userId,
    userName
  })
  const [userData, setUserData] = useState([]);
  const [facilityData, setFacilityData] = useState([]);
  const [clubData, setClubData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [members, setMembers] = useState(type === "create" ? [
    { id: 1, name: "", contact: "", email: "" },
  ] : []);

  const [bookedSlots, setBookedSLots] = useState([
    { start_date_time: "2025-05-27T15:07:00.000Z", end_date_time: "2025-05-29T16:07:00.000Z" },
    { start_date_time: "2025-05-30T10:00:00.000Z", end_date_time: "2025-05-30T11:00:00.000Z" }
  ]);

  const parsedSlots = bookedSlots.map(({ start_date_time: start, end_date_time: end }) => {
    if (typeof start !== 'string' || typeof end !== 'string') {
      console.error('Invalid date format:', { start, end });
      return null;
    }

    //console.log(start,end);
    return {
      start: parseISO(start),
      end: parseISO(end),
    };
  }).filter(Boolean);

  const isBlockedDate = (date) => parsedSlots.some(({ start, end }) => !isSameDay(date, start) && !isSameDay(date, end) && isWithinInterval(date, { start, end }));
  const isBlockedTime = (date) => parsedSlots.some(({ start, end }) => isWithinInterval(date, { start, end }));


  const [formData, setFormData] = useState({
    facility_id: fid,
    facility_registration_id: "",
    user_id: userId,
    club_id: clubId,
    purpose: type === "edit" ? formValues.data.purpose : "",
    // project_title: '',
    // mentors_name: '',
    start_date_time: type === "edit" ? dayjs(formValues.data.start_date_time).format("YYYY-MM-DDTHH:mm") : "",
    end_date_time: type === "edit" ? dayjs(formValues.data.end_date_time).format("YYYY-MM-DDTHH:mm") : "",
    description: type === "edit" ? formValues.data.description : "",
    club_name: clubName,
    alternate_contact_details: (type === "edit" && formValues.data.alternate_contact_details) ? JSON.parse(formValues.data.alternate_contact_details).members : [],
  });

  let [error, setError] = useState({
    facility_id: "",
    facility_registration_id: "",
    user_id: "",
    purpose: '',
    // project_title: '',
    // mentors_name: '',
    start_date_time: "",
    end_date_time: "",
    description: "",
    club_name: "",
    alternate_contact_details: [],
  });

  const getRole = () => {
    const token = localStorage.getItem("token");;
    if (!token) return null;
    try {
      return jwtDecode(token).role;
    } catch {
      return null;
    }
  };
  const role = getRole();
  const fetchBookedSlots = async () => {
    try {
      const res = await getBookedSlots(fid);
      if (res.data && res.data.timings) {
        const array = res.data.timings;
        setBookedSLots(array);
      } else {
        toast.error(`Something went wrong.`);
      }
    } catch (err) {
      toast.error(`Something went wrong, ${err}`);
    }
  }

  useEffect(() => {
    if (fid) {
      if (type === "edit") {
        JSON.parse(formValues.data.alternate_contact_details).members.map((Member) => {
          setMembers([
            ...members,
            {
              id: members.length + 1,
              contact: Member.contact,
              email: Member.email,
              name: Member.name
            }
          ])
        })
      }
    }
    fetchBookedSlots();
    //getFacilityDropdown();
    //getClubDropdown();
    //getUserDropdown();
  }, [fid]);

  function getFormValues(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError({ ...error, [e.target.name]: "" });
  }

  function validateForm() {
    let errors = {};
    let isValid = true;

    if (!formData.facility_id) {
      errors.facility_id = "Facility selection is required";
      isValid = false;
    }

    if (!formData.user_id) {
      errors.user_id = "User selection is required";
      isValid = false;
    }

    // if (!formData.project_title.trim()) {
    //   errors.project_title = "Project title is required";
    //   isValid = false;
    // }

    // if (!formData.mentors_name.trim()) {
    //   errors.mentors_name = "Mentor's name is required";
    //   isValid = false;
    // }
    if (!formData.purpose) {
      errors.purpose = "Purpose is required";
      isValid = false;
    }

    if (!formData.start_date_time) {
      errors.start_date_time = "Start date & time is required";
      isValid = false;
    }

    if (!formData.end_date_time) {
      errors.end_date_time = "End date & time is required";
      isValid = false;
    }

    if (!formData.description.trim()) {
      errors.description = "Description is required";
      isValid = false;
    }

    // if (
    //   members.length > 1 && 
    //   members.some(
    //     (member) =>
    //       !member.name.trim() || !member.contact.trim() || !member.email.trim()
    //   )
    // ) {
    //   errors.alternate_contact_details =
    //     "All team members must have name, contact, and email";
    //   isValid = false;
    // }
    setError(errors);
    return isValid;
  }

  // async function getfacilityDataById(id) {
  //   try {
  //     const token = localStorage.getItem("token");
  //     let response = await axios.get(
  //       "https://api.nvcti.in/facility/registration/getFacilityRegistrationById/" +
  //         id,
  //       // let response = await axios.get("https://api.nvcti.in/facility/registration/getFacilityRegistrationById/" + id,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     if (response.status === 200) {
  //       Updatedata = response.data;
  //       const parsedMembers = Updatedata.alternate_contact_details
  //         ? JSON.parse(Updatedata.alternate_contact_details).members.map(
  //             (member, index) => ({
  //               id: index + 1,
  //               name: member.name,
  //               contact: member.contact,
  //               email: member.email,
  //             })
  //           )
  //         : [{ id: 1, name: "", contact: "", email: "" }];

  //       setFormData({
  //         facility_registration_id: Updatedata
  //           ? Updatedata.facility_registration_id
  //           : "",
  //         facility_id: Updatedata.facility_id || "",
  //         user_id: Updatedata.user_id || "",
  //         club_name: Updatedata.club_name,
  //         // project_title: Updatedata.project_title || '',
  //         // mentors_name: Updatedata.mentors_name || '',
  //         start_date_time: Updatedata.start_date_time ||  "",
  //         end_date_time: Updatedata.end_date_time || "",
  //         description: Updatedata.description || "",
  //       });
  //       setMembers(parsedMembers);
  //     }
  //   } catch (error) {
  //     toast.error(error.response?.data?.message || "Something went wrong");
  //   }
  // }

  const handleAddMember = () => {
    // Check if any existing member has empty fields
    const isIncomplete = members.some(
      (member) =>
        !member.name.trim() || !member.contact.trim() || !member.email.trim()
    );
    if (isIncomplete) {
      toast.error(
        "Please fill all fields for the current member before adding a new one."
      );
      return;
    }
    setMembers([
      ...members,
      {
        id: members.length + 1,
        name: "",
        contact: "",
        email: "",
      },
    ]);
  };

  const handleRemoveMember = (id) => {
    if (members.length > 1) {
      setMembers(members.filter((member) => member.id !== id));
    } else {
      setMembers([{ id: 1, name: "", contact: "", email: "" }]);
      toast.error("At least one member is required");
    }
  };

  const handleMemberChange = (id, field, value) => {
    setMembers(
      members.map((member) =>
        member.id === id ? { ...member, [field]: value } : member
      )
    );
  };

  async function getFacilityDropdown() {
    try {
      const token = localStorage.getItem("token");
      const getApiResponse = await axios.get(
        "https://api.nvcti.in/facilities/getAllFacilities",
        {
          // const getApiResponse = await axios.get("https://api.nvcti.in/facilities/getAllFacilities", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setFacilityData(getApiResponse.data.data || []);
    } catch (error) {
      toast.error("Error fetching inventory:", error);
      setFacilityData([]);
    }
  }

  const loadFacilityOptions = async (inputValue, callback) => {
    try {
      if (!facilityData.length) {
        await getFacilityDropdown();
      }
      const filteredOptions = facilityData
        .filter((item) =>
          item?.name?.toLowerCase().includes(inputValue.toLowerCase() || [])
        )
        .map((item) => ({
          value: item.facility_id,
          label: item.facility_name,
        }));

      callback(filteredOptions);
    } catch (error) {
      toast.error("Error loading inventory options:", error);
      callback([]);
    }
  };

  async function getClubDropdown() {
    try {
      const token = localStorage.getItem("token");
      const getApiResponse = await axios.get(
        "https://api.nvcti.in/clubs/getAllClubs",
        {
          // const getApiResponse = await axios.get("https://api.nvcti.in/facilities/getAllFacilities", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setClubData(getApiResponse.data.data || []);
      // if(getApiResponse.data?.data){
      //   const club_name = (getApiResponse.data.data.find(item=>item.club_id===clubId)).club_name;
      //   setLoggedInUserInfo({...loggedInUserInfo, clubName:club_name});
      // }
    } catch (error) {
      toast.error("Error fetching inventory:", error);
      setClubData([]);
    }
  }

  const loadClubOptions = async (inputValue, callback) => {
    try {
      if (!facilityData.length) {
        await getClubDropdown();
      }
      const filteredOptions = facilityData
        .filter((item) =>
          item?.name?.toLowerCase().includes(inputValue.toLowerCase() || [])
        )
        .map((item) => ({
          value: item.club_id,
          label: item.club_name,
        }));

      callback(filteredOptions);
    } catch (error) {
      toast.error("Error loading clubs:", error);
      callback([]);
    }
  };

  async function getUserDropdown() {
    try {
      const token = localStorage.getItem("token");
      const getApiResponse = await axios.get(
        "https://api.nvcti.in/user/getAllUsers",
        {
          // const getApiResponse = await axios.get("https://api.nvcti.in/user/getAllUsers", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (getApiResponse.status == 200) {
        setUserData(getApiResponse.data.data);
        //   if(getApiResponse.data?.data){
        //   const user_name = getApiResponse.data.data.find(item=>item.user_id===userId).user_name;
        //   setLoggedInUserInfo({...loggedInUserInfo, userName:user_name});
        // }
      } else {
        setUserData([]);
      }
    } catch (error) {
      toast.error("Error fetching inventory:", error);
      setUserData([]);
    }
  }

  const loadUserOptions = async (inputValue, callback) => {
    try {
      if (!userData.length) {
        await getUserDropdown();
      }
      const filteredOptions = userData
        .filter((user) =>
          user.first_name.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((user) => ({
          value: user.user_id,
          label: user.first_name,
        }));

      callback(filteredOptions);
    } catch (error) {
      toast.error("Error loading user options:", error);
      callback([]);
    }
  };

  async function onSubmitFormData(e) {
    e.preventDefault();
    if (!validateForm()) return;
    const teamMembersData = {
      members: members.map((member) => ({
        name: member.name,
        contact: member.contact,
        email: member.email,
      })),
    };
    const submissionData = {
      facility_registration_id: formData.facility_registration_id,
      user_id: Number(formData.user_id),
      facility_id: Number(formData.facility_id),
      // project_title: formData.project_title,
      description: formData.description,
      club_id: 1,
      // club_id:Number(formData.club_id),
      club_name: formData.club_name,
      purpose: formData.purpose,
      // mentors_name: formData.mentors_name,
      alternate_contact_details: teamMembersData,
      start_date_time: dayjs(formData.start_date_time).toISOString(),
      end_date_time: dayjs(formData.end_date_time).toISOString(),
    };

    try {
      setLoading(true);
      let response;
      if (type === "create") {
        response = await addFacilityRegistration(submissionData);
      } else {
        response = await updateFacilityRegistration(submissionData, formValues.id);
      }

      if (response.status === 200 || response.status === 201) {
        toast.success(
          type === "edit"
            ? "Facility Reservation Updated Successfully!"
            : "Facility Reserved Successfully!"
        );
        navigate("/student/facilities");
      } else {
        toast.error("Somethiing went wrong. ");
      }

    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  }

  function clearFormData() {
    setFormData({
      facility_id: "",
      user_id: "",
      purpose: "",
      // project_title: '',  mentors_name: '',
      start_date_time: "",
      end_date_time: "",
      description: "",
      alternate_contact_details: [],
    });
    setError({
      facility_id: "",
      user_id: "",
      purpose: "",
      // project_title: '',  mentors_name: '',
      start_date_time: "",
      end_date_time: "",
      description: "",
      alternate_contact_details: [],
    });
  }

  return (
    <>
      <Toaster position="bottom-left" reverseOrder={false} />
      <SubmittingModal loading={loading} />
      <div className="flex justify-center items-center">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 mt-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
          <div className="rounded-t bg-white mb-0 px-6 py-6">
            <div className="text-center flex justify-between">
              <h6 className="text-blueGray-700 text-xl font-semibold">
                Facility Reservation
              </h6>
              <Tooltip title="View Applied Registrations" arrow>
                <button
                  className="bg-lightBlue-500 mb-0 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/student/viewFacilityRegistration`, { state: { fid: fid, fname: fname } });
                  }}>
                  View Registrations
                </button>
              </Tooltip>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form onSubmit={onSubmitFormData}>
              <h6 className="text-blueGray-700 text-xl mt-3 mb-6 font-semibold "> Description</h6>
              <div className="flex flex-wrap">
                <div className='flex justify-center w-full mb-3' >
                  <ImageCarouselInfo images={facility.facility_images} />
                </div>
                <div className="w-full lg:w-6/12 " >
                  <div className="relative w-full mb-3">
                    <span className="font-bold text-gray-700 w-40 capitalize">Name :</span>
                    <span className="text-gray-900 capitalize"> {facility.facility_name} </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 " >
                  <div className="relative w-full mb-3">
                    <span className="font-bold text-gray-700 w-40 capitalize">Location :</span>
                    <span className="text-gray-900"> {facility.location} </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 " >
                  <div className="relative w-full mb-3">
                    <span className="font-bold text-gray-700 w-40 capitalize">Capacity :</span>
                    <span className="text-gray-900"> {facility.capacity} </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 " >
                  <div className="relative w-full mb-3">
                    <span className="font-bold text-gray-700 w-40 capitalize">Slot :</span>
                    <span className="text-gray-900"> {facility.start_time} - {facility.end_time} </span>
                  </div>
                </div>

                <div className="w-full lg:w-12/12 " >
                  <div className="relative w-full mb-3">
                    <span className="font-bold text-gray-700 w-40 capitalize">Description :</span>
                    <span className="text-gray-900"> {facility.description} </span>
                  </div>
                </div>
              </div>
              <hr className='mt-3' />
              <h6 className="text-blueGray-400 text-xl mt-3 mb-6 font-semibold ">
                {type === "create"
                  ? "Create Facility Reservation"
                  : "Update Facility Reservation"}
              </h6>
              <div className="flex flex-wrap">
                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Select Facility
                    </label>
                    <AsyncSelect
                      disabled={true}
                      cacheOptions
                      loadOptions={loadFacilityOptions}
                      defaultOptions={facilityData.map((item) => ({
                        value: item.facility_id,
                        label: item.facility_name,
                      }))}
                      value={
                        facilityData.find(
                          (item) => item.facility_id === formData.facility_id
                        )
                          ? {
                              value: formData.facility_id,
                              label: facilityData.find(
                                (item) =>
                                  item.facility_id === formData.facility_id
                              ).facility_name,
                            }
                          :{
                            value: fid,
                            label: fname
                          }
                      }
                      onChange={(selectedOption) => {
                        setFormData({
                          ...formData,
                          facility_id: selectedOption?.value || "",
                        });
                        setError({ ...error, facility_id: "" });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Search Facility"
                      noOptionsMessage={() => "No Data Found"}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #D1D5DB",
                          padding: "0px",
                          height: "42px",
                          minHeight: "42px",
                          borderRadius: "0.375rem",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px #3B82F6"
                            : "none",
                          backgroundColor: state.isDisabled
                            ? "#F3F4F6"
                            : "white",
                          pointerEvents: state.isDisabled ? "none" : "auto",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#9CA3AF",
                          fontSize: "0.875rem",
                          paddingLeft: "8px",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: "6px 12px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "42px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0",
                          padding: "0",
                          border: "none",
                          boxShadow: "none",
                          "& input": {
                            border: "none !important",
                            boxShadow: "none !important",
                          },
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#3B82F6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "white",
                          color: state.isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "#3B82F6",
                          },
                        }),
                      }}
                    />
                    {error.facility_id && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.facility_id}
                      </p>
                    )}
                  </div>
                </div>

                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Select Clubs
                    </label>
                    <AsyncSelect
                  
                      cacheOptions
                      loadOptions={loadClubOptions}
                      defaultOptions={clubData.map((item) => ({
                        value: item.club_id,
                        label: item.club_name,
                      }))}
                      value={
                        clubData.find(
                          (item) => item.club_id === formData.club_id
                        )
                          ? {
                              value: formData.club_id,
                              label: clubData.find(
                                (item) => item.club_id === formData.club_id
                              ).club_name,
                            }
                          : {
                            value: loggedInUserInfo.clubId,
                            label: loggedInUserInfo.clubName
                          }
                      }
                      onChange={(selectedOption) => {
                        setFormData({
                          ...formData,
                          club_id: selectedOption?.value || "",
                        });
                        setError({ ...error, club_id: "" });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Search Facility"
                      noOptionsMessage={() => "No Data Found"}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #D1D5DB",
                          padding: "0px",
                          height: "42px",
                          minHeight: "42px",
                          borderRadius: "0.375rem",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px #3B82F6"
                            : "none",
                          backgroundColor: state.isDisabled
                            ? "#F3F4F6"
                            : "white",
                          pointerEvents: state.isDisabled ? "none" : "auto",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#9CA3AF",
                          fontSize: "0.875rem",
                          paddingLeft: "8px",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: "6px 12px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "42px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0",
                          padding: "0",
                          border: "none",
                          boxShadow: "none",
                          "& input": {
                            border: "none !important",
                            boxShadow: "none !important",
                          },
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#3B82F6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "white",
                          color: state.isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "#3B82F6",
                          },
                        }),
                      }}
                    />
                    {error.club_id && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.club_id}
                      </p>
                    )}
                  </div>
                </div>

                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block  text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Select User
                    </label>
                    <AsyncSelect
              
                      cacheOptions
                      loadOptions={loadUserOptions}
                      defaultOptions={userData.map((user) => ({
                        value: user.user_id,
                        label: user.first_name,
                      }))}
                      value={
                        userData.find(
                          (user) => user.user_id == formData.user_id
                        )
                          ? {
                              value: formData.user_id,
                              label: userData.find(
                                (user) => user.user_id == formData.user_id
                              ).first_name,
                            }
                          :{
                            value: loggedInUserInfo.userId,
                            label: loggedInUserInfo.userName
                          }
                      }
                      onChange={(selectedOption) => {
                        setFormData({
                          ...formData,
                          user_id: selectedOption.value,
                        });
                        setError({ ...error, user_id: "" });
                      }}
                      classNamePrefix="react-select"
                      placeholder="Search User"
                      noOptionsMessage={() => "No Data Found"}
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          border: "1px solid #D1D5DB",
                          padding: "0px",
                          height: "42px",
                          minHeight: "42px",
                          borderRadius: "0.375rem",
                          boxShadow: state.isFocused
                            ? "0 0 0 2px #3B82F6"
                            : "none",
                          backgroundColor: state.isDisabled
                            ? "#F3F4F6"
                            : "white",
                          pointerEvents: state.isDisabled ? "none" : "auto",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: "#9CA3AF",
                          fontSize: "0.875rem",
                          paddingLeft: "8px",
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          padding: "6px 12px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "42px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0",
                          padding: "0",
                          border: "none",
                          boxShadow: "none",
                          "& input": {
                            border: "none !important",
                            boxShadow: "none !important",
                          },
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected
                            ? "#3B82F6"
                            : state.isFocused
                            ? "#F3F4F6"
                            : "white",
                          color: state.isSelected ? "white" : "#111827",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: "#3B82F6",
                          },
                        }),
                      }}
                    />
                    {error.user_id && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.user_id}
                      </p>
                    )}
                  </div>
                </div> */}

                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                      Project Title
                    </label>
                    <input
                      placeholder='Project Title'
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
               
                      name="project_title"
                      type="text"
                      value={formData.project_title}
                      onChange={getFormValues}
                    />
                     {error.project_title && <p className="text-red-500 text-xs mt-1">{error.project_title}</p>}
                  </div>
                </div> */}

                {/* <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                      Mentor Name
                    </label>
                    <input
                      placeholder='Mentor Name'
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      name="mentors_name"
                      type="text"
                      value={formData.mentors_name}
           
                      onChange={getFormValues}
                    />
                     {error.mentors_name && <p className="text-red-500 text-xs mt-1">{error.mentors_name}</p>}
                  </div>
                </div> */}
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">Purpose <span className="text-red-500">*</span></label>
                    <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.purpose}
                      type="text"
                      name="purpose"
                      readOnly={type === "view"}
                      placeholder='Purpose'
                      onChange={getFormValues}
                    />
                    {error.purpose && <p className="text-red-500 text-xs mt-1">{error.purpose}</p>}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">
                      Start Date and Time <span className="text-red-500">*</span>
                    </label>
                    <DatePicker
                      selected={
                        formData.start_date_time
                          ? new Date(formData.start_date_time)
                          : null
                      }
                      onChange={(date) =>
                        getFormValues({
                          target: {
                            name: "start_date_time",
                            value: date,
                          },
                        })
                      }
                      showTimeSelect
                      dateFormat="yyyy-MM-dd HH:mm"
                      timeIntervals={30}
                      filterDate={(date) => !isBlockedDate(date)}
                      filterTime={(time) => !isBlockedTime(time)}
                      //dateFormat="Pp"
                      className="w-full border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150"
                      wrapperClassName="w-full"
                      //className="border border-gray-300 rounded px-4 py-2 shadow w-full"
                      placeholderText="yyyy-mm-dd hh:mm"
                    />

                    {/* <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.start_date_time}
                      type="datetime-local"
                      name="start_date_time"
                      onChange={getFormValues}
                    /> */}
                    {error.start_date_time && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.start_date_time}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block text-blueGray-600 text-xs font-bold mb-2">
                      End Date and Time <span className="text-red-500">*</span>
                    </label>
                    <DatePicker
                      selected={
                        formData.end_date_time
                          ? new Date(formData.end_date_time)
                          : null
                      }
                      onChange={(date) =>
                        getFormValues({
                          target: {
                            name: "end_date_time",
                            value: date,
                          },
                        })
                      }
                      showTimeSelect
                      dateFormat="yyyy-MM-dd HH:mm"
                      timeIntervals={30}
                      filterDate={(date) => !isBlockedDate(date)}
                      filterTime={(time) => !isBlockedTime(time)}
                      //dateFormat="Pp"
                      className="w-full border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150"
                      wrapperClassName="w-full"
                      //className="border border-gray-300 rounded px-4 py-2 shadow w-full"
                      placeholderText="yyyy-mm-dd hh:mm"
                    />

                    {/* <input
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={formData.end_date_time}
                      type="datetime-local"
                      name="end_date_time"
                  
                      onChange={getFormValues}
                    /> */}
                    {error.end_date_time && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.end_date_time}
                      </p>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-12/12 px-4">
                  <div className="relative w-full mb-3">
                    <label className="block  text-blueGray-600 text-xs font-bold mb-2">
                      Description <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      placeholder="Enter your description."
                      rows="4"
                      name="description"
                      value={formData.description}
                      onChange={getFormValues}
                    />
                    {error.description && (
                      <p className="text-red-500 text-xs mt-1">
                        {error.description}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <hr className="mt-6 border-b-1 border-blueGray-300" />
              <h6 className="text-blueGray-400 text-xl mt-3 mb-6 font-semibold ">
                Alternate Contact Details
              </h6>
              {members.map((member, index) => (
                <div key={member.id} className="w-full flex flex-wrap">
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        placeholder="Member Name"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        type="text"
                        value={member.name}
                        onChange={(e) =>
                          handleMemberChange(member.id, "name", e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Contact No <span className="text-red-500">*</span>
                      </label>
                      <input
                        placeholder="Contact No"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        maxLength={10}
                        type="text"
                        value={member.contact}
                        onChange={(e) =>
                          handleMemberChange(
                            member.id,
                            "contact",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">
                        Email <span className="text-red-500">*</span>
                      </label>
                      <input
                        placeholder="Email"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        type="email"
                        value={member.email}
                        onChange={(e) =>
                          handleMemberChange(member.id, "email", e.target.value)
                        }
                      />
                    </div>
                  </div>


                  <>
                    <div className="w-full lg:w-6/12 px-4">
                      <div className="relative w-full mb-6 flex gap-4 mt-6">
                        <Tooltip title="Add new member">
                          <button
                            className="bg-lightBlue-500  text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={handleAddMember}
                          >
                            <i className="fas fa-plus mr-2"></i> Add
                          </button>
                        </Tooltip>
                        <Tooltip title="Remove this member">
                          <button
                            className="bg-red-500  text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={() => handleRemoveMember(member.id)}
                            disabled={members.length === 1}
                          >
                            <i className="fas fa-times mr-2"></i> Cancel
                          </button>
                        </Tooltip>
                      </div>
                    </div>
                  </>

                </div>
              ))}
              <div className="flex justify-end w-full">
                <Tooltip title="Back" arrow>
                  <button
                    className="mt-10 text-white bg-blueGray-700 active:bg-blueGray-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-auto ease-linear transition-all duration-150"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/${role}/facilities`);
                      //window.location.href = `/${role}/facilites`;
                      clearFormData();
                    }}
                  >
                    {"<< "}Back
                  </button>
                </Tooltip>
                <>
                  <Tooltip title="Submit" arrow>
                    <button
                      className="bg-lightBlue-500 mt-10 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      type="submit"
                    >
                      {type === "create" ? "Submit" : "Update"}
                    </button>
                  </Tooltip>
                  <Tooltip title="Clear" arrow>
                    <button
                      className="bg-red-500 mt-10 text-white active:bg-lightBlue-600 font-semibold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                      type="button"
                    >
                      Clear
                    </button>
                  </Tooltip>
                </>

              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
